import logo1 from './logo.svg';
import EmailIcon from './EmailIcon.svg'
import MobileIcon from './mobileicon.svg';
export default {
	logos:{
		logo1,
		EmailIcon,
		MobileIcon
	}
}